import React, { Fragment } from 'react';
import { Row } from 'react-bootstrap';
import { StatCard } from './StatCard';
import {
  RIconFile,
  RIconPaperPlane,
  RIconPC,
  RIconPerson,
  RIconWarning,
} from '../../components/Icons';
import { RIconRRB } from '../../components/Icons/RIconRRB';
import { useSearchParams } from 'react-router-dom';
import { NumberFormat } from '../../utils/NumberFormat';

const CountWidget = ({ data = false, isSuperadmin = false }) => {
  const [searchParams] = useSearchParams();
  const manual = searchParams.get('man');
  if (!data) return;
  return (
    <Fragment>
      <StatCard
        icon={<RIconRRB />}
        bgClass='bg-cyan'
        title={!manual && isSuperadmin ? NumberFormat(data?.totalRrbs) : NumberFormat(data.totalDivisions)}
        subtitle={`${!manual && isSuperadmin ? 'RRBs' : 'Divisions'}`}
        colSize='col-6 col-md-4 col-xxl'
      />
      <StatCard
        icon={<RIconPC />}
        bgClass='bg-warning'
        title={NumberFormat(data?.centers)}
        subtitle='Exams Centers'
        colSize='col-6 col-md-4 col-xxl'
      />
      <StatCard
        icon={<RIconPerson />}
        bgClass='bg-yellow'
        title={NumberFormat(data?.centerCoordinators)}
        subtitle='Center Coordinators'
        colSize='col-6 col-md-4 col-xxl'
      />
      <StatCard
        icon={<RIconFile />}
        bgClass='bg-purple'
        title={NumberFormat(data?.totalExams)}
        subtitle='Exams'
        colSize='col-6 col-md-4 col-xxl'
      />
      <StatCard
        icon={<RIconPaperPlane width={30} height={28.73} />}
        bgClass='bg-success'
        title={NumberFormat(data?.reportsSubmitted)}
        subtitle='Reports Submitted'
        colSize='col-6 col-md-4 col-xxl'
      />

      <StatCard
        icon={<RIconWarning />}
        bgClass='bg-danger'
        title={NumberFormat(data?.reportedIncidents)}
        subtitle='Reported Incidents'
        colSize='col-6 col-md-4 col-xxl'
      />
    </Fragment>
  );
};

export default CountWidget;
